var _title, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPencilFill = function SvgPencilFill(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "pencil2")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.528 3.232c-1.12 1.088-5.872 5.52-10.528 9.872-4.672 4.336-8.784 8.208-9.152 8.592l-0.688 0.688v7.712l0.4 0.384 0.384 0.4h7.968l0.656-0.512c1.68-1.344 21.936-20.528 22.016-20.864 0.048-0.192 0.032-0.528-0.048-0.752-0.080-0.208-1.808-1.984-3.84-3.92-4.72-4.528-4.224-4.416-7.168-1.6zM25.76 6.896l2.32 2.224-1.312 1.296-1.328 1.296-1.872-1.76c-1.040-0.976-2.128-2.016-2.416-2.32l-0.528-0.544 1.328-1.232c0.72-0.672 1.36-1.216 1.408-1.216 0.048 0.016 1.12 1.024 2.4 2.256zM22.704 13.184c0.304 0.32 0.528 0.592 0.48 0.64-0.032 0.032-3.472 3.232-7.648 7.12l-7.584 7.056h-4.912v-4.432l7.712-7.216 7.712-7.2 1.856 1.728c1.008 0.96 2.080 1.984 2.384 2.304z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencilFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil-fill.4f0871e3.svg";
export { ForwardRef as ReactComponent };